import {MutationTree} from "vuex";
import {InvitesState} from "./InvitesState";

export const mutations: MutationTree<InvitesState> = {
    setDataHelper(state, dataHelper) {
        state.dataHelper = dataHelper;
    },
    setRepositories(state, repositories) {
        state.repositories = repositories;
    },
    setNotAnsweredCount(state, count) {
        state.invitesNotAnsweredCount = count;
    },
    setEventId(state, eventId) {
        state.eventId = eventId;
    },
    setMeetingCb(state, cb) {
        state.realTimeCbMeeting = cb;
    },
    setInviteCb(state, cb) {
        state.realTimeCbInvite = cb;
    }
}